import React, { useEffect } from "react";
import Header from "../../../../Components/Header/Header";
import RadarChart from "../../../../Components/Charts/RadarChart";
import brain from "../../../../Assets/Images/brain.svg";
import bulb from "../../../../Assets/Images/bulb.svg";
import multiUsers from "../../../../Assets/Images/multi-users.svg";
import sports from "../../../../Assets/Images/sports.svg";
import socio from "../../../../Assets/Images/socio.svg";
import Table from "./Components/Table";
import Card from "./Components/Card";
import Feedback from "./Components/Feedback";
import topLeftHand from "../../../../Assets/Images/left-hand.svg";
import topRightHand from "../../../../Assets/Images/right-hand.svg";
import hat from "../../../../Assets/Images/pink-hat.svg";
import hatBg from "../../../../Assets/Images/hat-bg.svg";
import apple from "../../../../Assets/Images/apple.svg";
import appleBg from "../../../../Assets/Images/apple-bg.svg";
import pinkBg from "../../../../Assets/Images/pink-bg.svg";
import rocket from "../../../../Assets/Images/rocket.svg";
import rocketBg from "../../../../Assets/Images/rocket-bg.svg";
import dice from "../../../../Assets/Images/blue-dice.svg";
import diceBg from "../../../../Assets/Images/dice-bg.svg";
import rightPinkBg from "../../../../Assets/Images/right-pinkBg.svg";
import logo from "../../../../Assets/Images/logo-kidex.svg";
import "./style.css";
import "./responsive.css";
import { useLocation } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { getReportCard } from "../../../../redux/actions/report";
import { radarConfigs } from "../../../../helper/general";
import Moment from "react-moment";
import { isMobileDevice } from "../../../../helper";
import QuizList from "./Components/QuizList";

const ViewReportCard = () => {

  const graphIcons = {
    "Cognitive Skills": brain,
    "Creativity & Imagination Skills": bulb,
    "Language & Communication Skills": multiUsers,
    "Physical Skills": sports,
    "Socio-Emotional Skills": socio
  }

  const isMobile = isMobileDevice();
  const location = useLocation();
  const dispatch = useDispatch();

  const kidId = location.state?.kidId

  const reportCard = useSelector(state => state.report.reportCard);

  useEffect(() => {
    if (kidId)
      dispatch(getReportCard({ kidId }))
  }, [kidId])

  const radarData = {
    labels: isMobile ? reportCard?.categories?.filter(item => item?.isTheme)?.map(item => "") : reportCard?.categories?.filter(item => item?.isTheme)?.map(item => (`${item?.category_name} ${Math.ceil(item?.percentage)}%`)),
    datasets: [
      {
        label: "",
        data: reportCard?.categories?.filter(item => item?.isTheme)?.map(item => Math.ceil(item?.percentage)),
        backgroundColor: "rgba(255, 210, 240,0.5)",
        borderColor: "#FFD2F0",
        fill: true,
      },
    ],
  }

  return (
    <React.Fragment>
      <Header dekstopSidebar="hidden" title="Report Card" school={reportCard?.school_display_name} city={reportCard?.state} />
      <div className="view-card text-center">
        <p className="name-hdng">{reportCard?.kid_name}</p>
        <p className="name-detail mb-0">{reportCard?.kid_class}</p>
        <p className="name-detail">{reportCard?.age} years old</p>
        <p className="marks-detail mx-auto">Overall Percentage Marks :<span className="ps-1"><b>{Math.ceil(reportCard?.overall_percentage)}%</b></span></p>
        <div className="chart-wrapp">
          <div className="chart-row">
            {isMobile &&
              <ul className="mob-report-list">
                {reportCard?.categories?.filter((item) => item?.isTheme)?.map((item) => {
                  return (
                    <li className="mb-1"><img className="img-brain mx-1" width={20} src={graphIcons[item?.category_name]} alt="brain" /> {item?.category_name}</li>
                  )
                })}
              </ul>
            }
            <div className="col-lg-7 figure-img d-flex justify-content-center mx-auto">
              <RadarChart chartData={radarData} options={radarConfigs} />
              <img className="img-brain" src={brain} alt="brain" />
              <img className="creativity-img" src={bulb} alt="bulb" />
              <img className="lang-img" src={multiUsers} alt="multiUsers" />
              <img className="phy-skill" src={sports} alt="sports" />
              <img className="socio-skill" src={socio} alt="socio" />
            </div>
          </div>
        </div>
        <p className="marks-detail score mx-auto">
          Holistic Development Score :
          <span className="ps-1">
            <b>{Math.ceil(reportCard?.overall_percentage)}%</b>
          </span>
        </p>
        <p className="description mx-auto my-4">
          The summary below shows status of scores obtained till the time this
          report card was generated. Next page shows grades available
          corresponding to each activity undertaken by the student
        </p>
        {reportCard?.quizes?.length > 0 && <QuizList data={reportCard?.quizes} />}
        <Table data={reportCard?.categories} />
        <div className="activity-w-score mt-6">
          <p className="para top-most mt-5">Activity Wise Score</p>
          <p className="para sub-hdng mb-0">KidEx Activities Score Board</p>
          {reportCard?.categories?.map((data, key) => <Card data={data} key={key} />)}
          <div className="points row text-start mb-5 mt-4">
            <div className="col-6 col-lg-3">
              <p>EX : Expert <span>(45 points)</span></p>
            </div>
            <div className="col-6 col-lg-3">
              <p>M : Master <span>(30 points)</span></p>
            </div>
            <div className="col-6 col-lg-3">
              <p>I : Intermediate <span>(24 points)</span></p>
            </div>
            <div className="col-6 col-lg-3">
              <p>B : Beginner <span>(15 points)</span></p>
            </div>
            <div className="col-6 col-lg-3">
              <p>A : Aspirant <span>(7.5 points)</span></p>
            </div>
            <div className="col-6 col-lg-3">
              <p>NA : Not Applicable <span>(0 points)</span></p>
            </div>
            <div className="col-6 col-lg-3">
              <p>NS : Not Submitted <span>(0 points)</span></p>
            </div>
            <div className="col-6 col-lg-3">
              <p>GA : Grade Awaited <span>(TBD)</span></p>
            </div>
          </div>
          {reportCard?.overall_feedback &&
            <div className="feedback mb-5">
              <h5 className="mb-4 fw-bold">Overall Feedback</h5>
              <p className="text-start fw-semibold">{reportCard?.overall_feedback}</p>
              <p className="writer text-start">-{reportCard?.edited_by}</p>
            </div>
          }
        </div>
        <div className="view-card-bgImages">
          <img src={topLeftHand} alt="topLeftHand" className="topLeftHand" style={{ width: "7rem", height: "7rem" }} />
          <img src={topRightHand} alt="topRightHand" className="topRightHand" style={{ width: "7rem", height: "7rem" }} />
          <div className="hat-outr">
            <img src={hatBg} alt="hatBg" className="hatBg" style={{ width: "9rem", height: "8rem" }} />
            <img src={hat} alt="hat" className="hat" style={{ width: "7rem", height: "7rem" }} />
          </div>
          <img src={pinkBg} alt="pinkBg" className="pinkBg" style={{ width: "8rem", height: "8rem" }} />
          <div className="apple-outr">
            <img src={appleBg} alt="appleBg" className="appleBg" style={{ width: "10rem", height: "10rem" }} />
            <img src={apple} alt="apple" className="apple" style={{ width: "5rem", height: "5rem" }} />
          </div>
          <div className="rocket-outr">
            <img src={rocket} alt="rocket" className="rocket" style={{ width: "8rem", height: "8rem" }} />
            <img src={rocketBg} alt="rocketBg" className="rocketBg" style={{ width: "7rem", height: "7rem" }} />
          </div>
          <div className="dice-outr">
            <img src={diceBg} alt="diceBg" className="diceBg" style={{ width: "7rem", height: "7rem" }} />
            <img src={dice} alt="dice" className="dice" style={{ width: "3.5rem", height: "3.5rem" }} />
          </div>
          <img src={rightPinkBg} alt="rightPinkBg" className="rightPinkBg" style={{ width: "7rem", height: "7rem" }} />
          <div className="upper-logo text-end">
            <img src={logo} alt="logo" className="mb-2" style={{ width: "6rem", height: "2rem" }} />
            <p className="fw-semibold"><Moment format="DD MMMM YYYY, hh:mm a">{new Date()}</Moment></p>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ViewReportCard;
